import styled from "styled-components";

// Estilos del paso 3 del alta de empresa (datos, documentación y representantes), según el mockup

/** Agrupa las secciones: con disabled (empresa ya enviada) deja todos los campos en solo lectura. */
export const FormFieldset = styled.fieldset`
    border: 0;
    margin: 0;
    padding: 0;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const CheckRow = styled.label`
    display: inline-flex;
    align-items: center;
    gap: 10px;
    font-size: 15px;
    font-weight: 500;
    color: #2a4143;
    cursor: pointer;

    input
    {
        width: 18px;
        height: 18px;
        margin: 0;
        accent-color: ${(props) => props.theme?.palette?.themePrimary || "#CC214F"};
    }
`;

export const YesNoRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    padding: 14px 0;
    border-top: 1px solid #E3E8EB;
    font-size: 15px;
    font-weight: 500;
    color: #2a4143;

    > div
    {
        display: flex;
        gap: 8px;
    }

    @media screen and (max-width: 599px)
    {
        flex-direction: column;
        align-items: flex-start;
    }
`;

export const Pill = styled.label<{ $checked: boolean }>`
    height: 42px;
    padding: 0 18px;
    border: 1px solid ${(props) => (props.$checked ? props.theme?.palette?.themePrimary || "#CC214F" : "#D6DEE2")};
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: ${(props) => (props.$checked ? "#FBE9EE" : "#ffffff")};
    color: ${(props) => (props.$checked ? "#9E1737" : "#2a4143")};
    font-weight: ${(props) => (props.$checked ? 600 : 400)};
    font-size: 15px;
    cursor: pointer;

    input
    {
        margin: 0;
        accent-color: ${(props) => props.theme?.palette?.themePrimary || "#CC214F"};
    }
`;

export const DocumentBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding-top: 20px;
    border-top: 1px solid #E3E8EB;

    > b
    {
        font-size: 15px;
        color: #2a4143;
    }

    > small
    {
        font-size: 13px;
        color: #5A6A6E;
    }
`;

export const DropZone = styled.div`
    border: 1.5px dashed #C3CDD1;
    border-radius: 14px;
    background: #ffffff;
    padding: 20px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
    flex-wrap: wrap;
    font-size: 14px;
    color: #5A6A6E;

    input[type="file"]
    {
        display: none;
    }
`;

export const DocumentTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    background: #ffffff;
    border-radius: 14px;
    overflow: hidden;

    th
    {
        font-size: 13px;
        font-weight: 600;
        color: #5A6A6E;
        text-align: left;
        padding: 12px 16px;
        background: #EAEFF2;
    }

    td
    {
        font-size: 15px;
        color: #2a4143;
        padding: 12px 16px;
        border-top: 1px solid #E3E8EB;
        word-break: break-word;
    }

    td.empty
    {
        font-size: 14px;
        color: #5A6A6E;
        text-align: center;
    }

    td.actions
    {
        width: 1%;
        white-space: nowrap;
        text-align: right;
    }
`;

export const LinkButton = styled.button`
    border: 0;
    background: transparent;
    padding: 4px 8px;
    color: ${(props) => props.theme?.palette?.themePrimary || "#CC214F"};
    font: inherit;
    font-weight: 600;
    cursor: pointer;

    &:disabled
    {
        color: #95A0A1;
        cursor: default;
    }
`;

export const RepresentativeAddRow = styled.div`
    display: flex;
    gap: 16px;
    align-items: flex-end;
    flex-wrap: wrap;

    > label
    {
        flex: 1 1 280px;
    }
`;

export const RepresentativeCard = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1.6fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 0.8fr) 40px;
    gap: 16px;
    align-items: end;
    background: #ffffff;
    border: 1px solid #E3E8EB;
    border-radius: 16px;
    padding: 16px 18px;

    .who
    {
        display: flex;
        flex-direction: column;
        gap: 2px;
        align-self: center;

        b
        {
            font-size: 15px;
        }

        small
        {
            font-size: 13px;
            color: #5A6A6E;
        }
    }

    @media screen and (max-width: 991px)
    {
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    }
`;

export const DetailsFooter = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    padding: 24px 32px;
    border: 1px solid #E3E8EB;
    border-radius: 24px;
    background: #ffffff;

    > label
    {
        flex: 1 1 320px;
    }

    @media screen and (max-width: 767px)
    {
        flex-direction: column;
        align-items: stretch;
        padding: 20px 16px;
    }
`;

/** Índice lateral a la izquierda y las secciones a la derecha; en pantallas estrechas solo las secciones. */
export const DetailsLayout = styled.div`
    display: flex;
    gap: 32px;
    align-items: flex-start;

    > div
    {
        flex-grow: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: 24px;
    }
`;

export const SectionNav = styled.nav`
    width: 232px;
    flex-shrink: 0;
    position: sticky;
    top: 24px;
    display: flex;
    flex-direction: column;
    gap: 2px;

    > span
    {
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 0.6px;
        color: #5A6A6E;
        padding: 0 14px 10px;
        cursor: default;
    }

    a
    {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 10px 14px;
        border-radius: 12px;
        color: #2a4143;
        text-decoration: none;
        font-size: 15px;
        font-weight: 500;
    }

    a:hover
    {
        background: #F3F6F8;
        color: #2a4143;
    }

    a i
    {
        font-style: normal;
        width: 24px;
        height: 24px;
        flex-shrink: 0;
        border-radius: 50%;
        border: 1.5px solid #C3CDD1;
        box-sizing: border-box;
        font-size: 12px;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #5A6A6E;
    }

    a.active
    {
        background: #FBE9EE;
        color: #9E1737;
    }

    a.active i
    {
        border-color: ${(props) => props.theme?.palette?.themePrimary || "#CC214F"};
        background: ${(props) => props.theme?.palette?.themePrimary || "#CC214F"};
        color: #ffffff;
    }

    @media screen and (max-width: 991px)
    {
        display: none;
    }
`;
